import './screen-size';
import './navigation';
import './table-of-contents';
import './togglize';
import './columnize';
import 'SLICK/slick.js';
import '../lib/magnific-popup/jquery.magnific-popup';
import './hero-video';
import './tabbit';

(function ($) {

  $(document).ready(function () {

    console.log('starter theme...');


    $(".fpcard-buttons").on('click', function (e) {
      let $target = $(e.target);
      let pressed = $target.attr('aria-pressed') === 'true';
      if (pressed) {
        return;
      }
      let imageType = $target.data('filter');
      $target.attr('aria-pressed', 'true');
      $target.siblings().attr('aria-pressed', 'false');
      $(this).parent().find(`.fpcard-wrapper[data-filter-match="${imageType}"]`).prop('hidden', false).siblings('.fpcard-wrapper').prop('hidden', true);
    });


    function reduceAllMotion() {
      console.log('reducing motion...');
      $('video').prop('autoplay', false)
        .siblings('.video-control-button-container').find('.video-control-button').attr('aria-label', 'play');
    }

    /**
     * Flag Prefers Reduced Motion
     */
    const reducedMotionMediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!reducedMotionMediaQuery || reducedMotionMediaQuery.matches) {
      reduceAllMotion();
    }

    let $faqToggles = $(".faq-column").togglize({ action: "toggle", animate: true, animateSpeed: "1s", firstOpen: false, adaptiveHeight: true });
    let $toggles = $(".togglize-me").togglize({ action: "toggle", animate: true, animateSpeed: "1s", firstOpen: false });
    let $accordions = $(".accordionize-me").togglize({ action: "accordion", animate: true, animateSpeed: "0.75s" })
    let twoCols = $(".two-col-content").twoColumnize()

    $('.hero-image-carousel').slick({
      infinite: true,
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      centerMode: false,
      dots: true,
      arrows: true,
      nextArrow: `<button type="button" class="carousel-button carousel-next">
			        <svg aria-hidden="true" focusable="false"  xmlns="http://www.w3.org/2000/svg" height="24" viewBox="400 -710 50 460" width="24"><path d="m517.847-480-184-184L376-706.153 602.153-480 376-253.847 333.847-296l184-184Z"/></svg>
			        <span class="sr-only">Next arrow</span>
		          </button>`,
      prevArrow: `<button type="button" class="carousel-button carousel-prev">
			      <svg  aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="480 -710 50 460" width="24"><path d="M560-253.847 333.847-480 560-706.153 602.153-664l-184 184 184 184L560-253.847Z"/></svg>
			      <span class="sr-only">Previous arrow</span>
		        </button>`,
      rows: 0,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
          }
        }
      ]
    })

    let imageCarouselCenterModeDesktop = false;
    let isImageCarouselDirRTL = false;
    if (window.imageCarouselDirection === 'rtl') {
      isImageCarouselDirRTL = true;
    }
    console.log('dir config: ', isImageCarouselDirRTL);
    if (window.imageCarouselSlidesShowDesktop == 1) {
      imageCarouselCenterModeDesktop = true;
    }
    let writingModeRightArrowText = 'Next Image';
    let writingModeLeftArrowText = 'Previous Image';
    if (isImageCarouselDirRTL) {
      writingModeRightArrowText = 'Previous Image';
      writingModeLeftArrowText = 'Next Image';
    }
    const rightArrowMarkup =
      `<button type="button" class="carousel-button carousel-next">
			<svg aria-hidden="true" focusable="false"  xmlns="http://www.w3.org/2000/svg" height="24" viewBox="400 -710 50 460" width="24"><path d="m517.847-480-184-184L376-706.153 602.153-480 376-253.847 333.847-296l184-184Z"/></svg>
			<span class="sr-only">${writingModeRightArrowText}</span>
		</button>`;
    const leftArrowMarkup =
      `<button type="button" class="carousel-button carousel-prev">
			<svg  aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="480 -710 50 460" width="24"><path d="M560-253.847 333.847-480 560-706.153 602.153-664l-184 184 184 184L560-253.847Z"/></svg>
			<span class="sr-only">${writingModeLeftArrowText}</span>
		</button>`;
    let writingModeNextArrow = rightArrowMarkup;
    let writingModePrevArrow = leftArrowMarkup;
    if (isImageCarouselDirRTL) {
      writingModeNextArrow = leftArrowMarkup;
      writingModePrevArrow = rightArrowMarkup;
    }
    $('.image-carousel').slick({
      rtl: isImageCarouselDirRTL,
      infinite: window.imageCarouselInfiniteSlider,
      slidesToShow: window.imageCarouselSlidesShowDesktop,
      centerMode: imageCarouselCenterModeDesktop,
      centerPadding: '10%',
      dots: true,
      arrows: true,
      nextArrow: writingModeNextArrow,
      prevArrow: writingModePrevArrow,
      // rows: 0,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '4rem'
          }
        }
      ]
    })

    $('.testimonial-slider').slick({
      infinite: true,
      slidesToShow: 2,
      centerMode: true,
      centerPadding: '4rem',
      dots: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        },
      ]
    });

    // $('.card').magnificPopup({
    //   delegate: 'img',
    //    type:'image'
    // });


    $(".hdoc-lightbox-gallery").magnificPopup({
      type: "image",
      gallery: {
        enabled: true
      },
      closeOnContentClick: true
    });

    $(".card-lightbox").magnificPopup({
      type: 'image',
      closeOnContentClick: true
    });

    // $(".fp-button").magnificPopup({
    //   type:'inline',
    //   closeOnContentClick: true
    // });

    $(".vr-button").magnificPopup({
      type: 'inline',
      closeOnContentClick: true
    });

    $(".fp-gallery-button").on("click", function (e) {

      e.stopPropagation();
      e.preventDefault();
      console.log("button clickedddddd")
      console.log('this: ', this);
      let targetGallerySelector = $(this).attr("href") //jquery next fp-gallery-class  
      // let $targetGallery = $(this).next() //jquery next fp-gallery-class  
      // console.log('targetGallery: ', $targetGallery);
      let $items = [];
      console.log('gallery children: ', $(targetGallerySelector).children('.fp-photo'));
      $(targetGallerySelector)
        .children(".fp-photo")
        .each(function (i, li) {
          $items.push({ src: $(li).children("img").attr("src"), title: $(li).children("p") });
        });

      console.log('items: ', $items);
      $.magnificPopup.open({
        items: $items,
        type: "image",
        gallery: {
          enabled: true
        },
      });
    });

    // const fpWidgetTabbed = $("#floor-plans-widget").tabbit(
    //   {
    //     tabIdCreation: "href"
    //   }
    //  )


    $('.create-floor-plan-tab').tabbit();



  })
})(jQuery);